var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-header__left"},[_vm._t("back")],2),_c('div',{staticClass:"card-header__title",class:{ 'card-header__title--centered': _vm.hasBackSlot },style:({ fontSize: _vm.fontSize + 'px' })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"card-header__right"},[_vm._t("extra")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }